import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import {auth} from '../../config/firebase';

function SignIn() {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(true);
  const [error, setError] = useState('');

  const navigate = useNavigate();

  // Check if user is already logged in or if there's a remembered email on page load
  useEffect(() => {
    const storedEmail = localStorage.getItem('rememberedEmail');
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn === 'true') {
      navigate('/dashboard'); // Redirect to dashboard if already logged in
    } else if (storedEmail) {
      setEmail(storedEmail); // Pre-fill email if remembered
    }
  }, [navigate]);

  // Validate the form inputs
  const validateForm = () => {
    const emailPattern = /\S+@\S+\.\S+/; // Simple regex for email validation
    if (!emailPattern.test(email)) {
      return 'Please enter a valid email address.';
    }
    if (password.length < 6 || !/\d/.test(password)) {
      return 'Password must be at least 6 characters long and include a number.';
    }
    return '';
  };

  // Handle user sign-in
  const handleSignIn = async (event) => {
    event.preventDefault(); // Prevent default form submission
    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Store email in localStorage if "Remember me" is checked
      if (rememberMe) {
        localStorage.setItem('rememberedEmail', email);
      } else {
        localStorage.removeItem('rememberedEmail');
      }
      // Mark user as logged in globally (only if they successfully login)
      localStorage.setItem('isLoggedIn', 'true'); 
      navigate('/'); // Navigate to the dashboard if credentials are correct
      setError('');
      console.log('Successfully logged in user', user);
    } catch (error) {
      console.error(error.code, error.message);
      setError(error.message); // Display error message to user
    }
  };

  return (
    <form className="space-y-6" onSubmit={handleSignIn}>
      <div className="space-y-1">
        <label htmlFor="email" className="text-sm font-medium">
          Email
        </label>
        <input
          type="email"
          id="email"
          name="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="block w-full rounded-lg border border-gray-200 px-5 py-3 leading-6 placeholder-gray-500 focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:placeholder-gray-400 dark:focus:border-primary-500"
        />
      </div>

      <div className="space-y-1">
        <label htmlFor="password" className="text-sm font-medium">
          Password
        </label>
        <input
          type="password"
          id="password"
          name="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter your password"
          className="block w-full rounded-lg border border-gray-200 px-5 py-3 leading-6 placeholder-gray-500 focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:placeholder-gray-400 dark:focus:border-primary-500"
        />
      </div>

      <div className="mb-5 flex items-center justify-between space-x-2">
        <label className="flex items-center">
          <input
            type="checkbox"
            id="remember_me"
            name="remember_me"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
            className="size-4 rounded border border-gray-200 text-primary-500 focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:ring-offset-gray-900 dark:checked:border-transparent dark:checked:bg-primary-500 dark:focus:border-primary-500"
          />
          <span className="ml-2 text-sm">Remember me</span>
        </label>
        {/* <Link
          to="/#"
          className="inline-block text-sm font-medium text-primary-600 hover:text-primary-400 dark:text-primary-400 dark:hover:text-primary-300"
        >
          Forgot Password?
        </Link> */}
      </div>

      {error && <p className="mb-4 text-sm text-red-500">{error}</p>}

      <button
        type="submit"
        className="inline-flex w-full items-center justify-center space-x-2 rounded-lg border border-teal-700 bg-teal-700 px-6 py-3 font-semibold leading-6 text-white hover:border-primary-600 hover:bg-primary-600 hover:text-white focus:ring focus:ring-primary-400 focus:ring-opacity-50 active:border-primary-700 active:bg-primary-700 dark:focus:ring-primary-400 dark:focus:ring-opacity-90"
      >
        <svg
          className="hi-mini hi-arrow-uturn-right inline-block size-5 opacity-50"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.207 2.232a.75.75 0 00.025 1.06l4.146 3.958H6.375a5.375 5.375 0 000 10.75H9.25a.75.75 0 000-1.5H6.375a3.875 3.875 0 010-7.75h10.003l-4.146 3.957a.75.75 0 001.036 1.085l5.5-5.25a.75.75 0 000-1.085l-5.5-5.25a.75.75 0 00-1.06.025z"
          />
        </svg>
        <span>Sign In</span>
      </button>
    </form>
  );
}

export default SignIn;
